import { FaLinkedinIn, FaTwitter, FaInstagram } from "react-icons/fa";

import lorde from "../../images/team-wth/Lorde.png";
import jay from "../../images/team-wth/Jay.png";
import ope from "../../images/team-wth/Ohhpee.png";
import naima from "../../images/team-wth/Naima.png";
import ali from "../../images/team-wth/Ali.png";
import shivam from "../../images/team-wth/Shivam.png";
import avatarThumb7 from "../../images/team/crew_avatar7.png";
import avatarThumb8 from "../../images/team/crew_avatar8.png";

const data = [
  {
    avatar: lorde,
    name: "Lorde Ambrose",
    designation: "Founder",
    socialLinks: [
      {
        icon: <FaLinkedinIn />,
        url: "#",
      },
      {
        icon: <FaTwitter />,
        url: "#",
      },
      {
        icon: <FaInstagram />,
        url: "#",
      },
    ],
  },
  {
    avatar: jay,
    name: "Jay Sandu",
    designation: "Partner",
    socialLinks: [
      {
        icon: <FaLinkedinIn />,
        url: "#",
      },
      {
        icon: <FaTwitter />,
        url: "#",
      },
      {
        icon: <FaInstagram />,
        url: "#",
      },
    ],
  },
  {
    avatar: ope,
    name: "OhhPee",
    designation: "Artist",
    socialLinks: [
      {
        icon: <FaLinkedinIn />,
        url: "#",
      },
      {
        icon: <FaTwitter />,
        url: "#",
      },
      {
        icon: <FaInstagram />,
        url: "#",
      },
    ],
  },
  {
    avatar: shivam,
    name: "Siman Paul",
    designation: "Solidity Developer",
    socialLinks: [
      {
        icon: <FaLinkedinIn />,
        url: "#",
      },
      {
        icon: <FaTwitter />,
        url: "#",
      },
      {
        icon: <FaInstagram />,
        url: "#",
      },
    ],
  },
  {
    avatar: ali,
    name: "ALI",
    designation: "Discord Manager",
    socialLinks: [
      {
        icon: <FaLinkedinIn />,
        url: "#",
      },
      {
        icon: <FaTwitter />,
        url: "#",
      },
      {
        icon: <FaInstagram />,
        url: "#",
      },
    ],
  },
  {
    avatar: naima,
    name: "Naima GHM",
    designation: "Project Manager",
    socialLinks: [
      {
        icon: <FaLinkedinIn />,
        url: "#",
      },
      {
        icon: <FaTwitter />,
        url: "#",
      },
      {
        icon: <FaInstagram />,
        url: "#",
      },
    ],
  },
  // {
  //   avatar: avatarThumb7,
  //   name: "Sony Jina",
  //   designation: "Blockchain Dev",
  //   socialLinks: [
  //     {
  //       icon: <FaLinkedinIn />,
  //       url: "#",
  //     },
  //     {
  //       icon: <FaTwitter />,
  //       url: "#",
  //     },
  //     {
  //       icon: <FaInstagram />,
  //       url: "#",
  //     },
  //   ],
  // },
  // {
  //   avatar: avatarThumb8,
  //   name: "Natala Elon",
  //   designation: "SEO Engineer",
  //   socialLinks: [
  //     {
  //       icon: <FaLinkedinIn />,
  //       url: "#",
  //     },
  //     {
  //       icon: <FaTwitter />,
  //       url: "#",
  //     },
  //     {
  //       icon: <FaInstagram />,
  //       url: "#",
  //     },
  //   ],
  // },
];

export default data;
